import { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import api from '../../utils/api'

/**
 * Component to display recommendations for a specific media object
 *
 * @param {string} mediaType - The type of media (song, album, playlist, mix, collage)
 * @param {number} mediaId - The ID of the media object
 * @param {function} onLoad - Optional callback that receives true if recommendations exist, false otherwise
 */
function MediaRecommendations({ mediaType, mediaId, onLoad }) {
  const [recommendations, setRecommendations] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const fetchRecommendations = async () => {
      try {
        setLoading(true)

        // Fetch recommendations for this specific media object
        const response = await api.get('get-recs/')

        // Filter for recommendations of this media object
        const filteredRecs = response.data.filter(
          (rec) => rec.media_type === mediaType && rec.media_id === parseInt(mediaId)
        )

        setRecommendations(filteredRecs)

        // Notify parent component if we have recommendations
        if (onLoad) {
          onLoad(filteredRecs.length > 0)
        }
      } catch (error) {
        console.error('Error fetching recommendations:', error)
        if (onLoad) {
          onLoad(false)
        }
      } finally {
        setLoading(false)
      }
    }

    if (mediaType && mediaId) {
      fetchRecommendations()
    }
  }, [mediaType, mediaId, onLoad])

  // If no recommendations or still loading, don't render anything
  if (loading || recommendations.length === 0) {
    return null
  }

  return (
    <div className='left-justify mt-6 text-left text-sm' style={{ padding: '0 10px' }}>
      <span className='metadata-text secondary'>rec'd: </span>
      {recommendations.map((rec, index) => (
        <span key={rec.id}>
          {index > 0 && <span className='metadata-text secondary mx-1'>/</span>}
          <Link to={`/profile/${rec.sender}`} className='text-contextPrimary hover:underline'>
            {rec.sender}
          </Link>
          {rec.message && (
            <span className='metadata-text secondary ml-1 italic'>{rec.message}</span>
          )}
        </span>
      ))}
    </div>
  )
}

export default MediaRecommendations
